<div class="flex-container">
  <!-- left column -->
  <div class="flex-container-column">
    <div class="flex-container">
      <span class="flex-item"><b>{{ 'businessSearchResultPreview.city' | transloco }}</b></span>
      <span class="flex-item-2">{{ result.address?.city }}</span>
    </div>
    
    <div class="flex-container">
      <span class="flex-item"><b>{{ 'businessSearchResultPreview.normalizedType' | transloco }}</b></span>
      <span class="flex-item-2">{{ result.normalizedEntityType | enumLabel:'normalizedEntityType' }}</span>
    </div>

    <div class="flex-container">
      <span class="flex-item"><b>{{ 'businessSearchResultPreview.type' | transloco }}</b></span>
      <span class="flex-item-2">{{ result.companyType }}</span>
    </div>

    <div class="flex-container">
      <span class="flex-item"><b>{{ 'businessSearchResultPreview.description' | transloco }}</b></span>
      <span class="flex-item-2">{{ result.description }}</span>
    </div>

    <div class="flex-container">
      <span class="flex-item"><b>{{ 'businessSearchResultPreview.jurisdictionStatus' | transloco }}</b></span>
      <span class="flex-item-2">{{ result.jurisdictionStatus }}</span>
    </div>
  </div>

  <!-- right column -->
  <div class="flex-container-column">
    <div class="flex-container">
      <span class="flex-item"><b>{{ 'businessSearchResultPreview.creationDate' | transloco }}</b></span>
      <span class="flex-item-2">{{ result.creationDate | localizedDate: 'yyyy-MM-dd' }}</span>
    </div>

    <div class="flex-container">
      <span class="flex-item"><b>{{ 'businessSearchResultPreview.statusDate' | transloco }}</b></span>
      <span class="flex-item-2">{{ result.statusDate | localizedDate: 'yyyy-MM-dd' }}</span>
    </div>

    @if (result.isCharity ?? false) {
    <div class="flex-container">
      <span class="flex-item"><b>{{ 'businessSearchResultPreview.craRegisteredCharity' | transloco }}</b></span>
      <span class="flex-item-2">{{ 'common.buttons.yes' | transloco }}</span>
    </div>
    }
  </div>
</div>

@if (result.businessReports && result.businessReports.length > 0) {
  <div class="flex-container">
    <span class="flex-item"><b>{{ 'businessSearchResultPreview.viewPreviousReport' | transloco }}</b></span>
    <mat-form-field appearance="outline" class="flex-item-2">
      <mat-label>{{ 'businessSearchResultPreview.previousReports' | transloco }}</mat-label>
      <mat-select (selectionChange)="onReportSelected($event.value)">
        @for (report of getReports(); track report) {
          <mat-option [value]="report.businessReportOrderID">
            {{ report.added | localizedDate: 'yyyy-MM-dd' }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <span class="flex-item">&nbsp;</span>
    <span class="flex-item-2">&nbsp;</span>
  </div>
}